<template>
  <div class="section">
    <div class="container center max-width-mobile">
      <h2 class="title title--3">Select a Department</h2>
      <div
        v-if="loading"
        class="loader"
      />
      <ul v-else>
        <li
          v-for="department in departments"
          :key="department.publicId"
        >
          <router-link
            :to="{ name: 'departmentTipping', params: {departmentId: department.publicId} }"
            class="department-card"
            :style="department.photoUrl && { 'background-image': `url(${department.photoUrl})` }"
          >
            <span>{{ department.name }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import events from '@/services/events';
  import { mapGetters, mapState } from 'vuex';

  export default {
    name: 'DepartmentList',

    metaInfo() {
      return {
        title: 'Departments'
      };
    },

    data: () => ({
      loading: true
    }),

    computed: {
      ...mapState('hotels', ['departments']),
      ...mapGetters('locations', ['searchResults']),
      ...mapGetters('merchant', ['merchant'])
    },

    async created() {
      this.onCreated();
    },

    methods: {
      onCreated() {
        if (this.$route.query.storeId) {
          this.fetchDepartments(this.$route.query.storeId);
        }
        else {
          this.getCurrentPosition();
        }
      },

      getCurrentPosition() {
        window.navigator.geolocation.getCurrentPosition(
          this.getCurrentPositionSuccess,
          this.getCurrentPositionError,
          { timeout: 10000 }
        );
      },

      getCurrentPositionError() {
        events.emit('notification', {
          type: 'error',
          message: 'Couldn\'t find your current location. Please check your browser settings.',
          duration: 4000
        });
        this.loading = false;
      },

      async getCurrentPositionSuccess({ coords }) {
        await this.$store.dispatch('locations/searchLocations', {
          distance: this.merchant.options.searchRadiusInMiles || 50,
          latitude: coords.latitude,
          longitude: coords.longitude
        });

        const { locations } = this.searchResults;

        if (locations.length) {
          this.fetchDepartments(locations[0].storeId);
        }
        else {
          this.loading = false;
          events.emit('notification', {
            type: 'error',
            message: 'Couldn\'t find any departments near your current location.',
            clickToDismiss: true
          });
        }
      },

      async fetchDepartments(storeId) {
        await this.$store.dispatch('hotels/fetchDepartments', storeId);
        this.loading = false;
      }
    }
  };
</script>
